import React from 'react';
import { Card } from './Card';
interface KPICardProps {
  title: string;
  value: string | number;
  icon?: React.ReactNode;
  variant?: 'default' | 'positive' | 'neutral' | 'negative';
  change?: string;
  trend?: 'up' | 'down';
  subtext?: string;
}
export function KPICard({
  title,
  value,
  icon,
  variant = 'default',
  change,
  trend,
  subtext
}: KPICardProps) {
  const variantStyles = {
    default: {
      bg: '',
      iconColor: 'text-aldi-blue opacity-80',
      titleColor: 'text-gray-500',
      valueColor: 'text-gray-900'
    },
    positive: {
      bg: 'bg-[#e8f5e4] border-[#639754]/20',
      iconColor: 'text-[#639754]',
      titleColor: 'text-[#4a7340]',
      valueColor: 'text-[#2d5a1e]'
    },
    neutral: {
      bg: 'bg-[#fffbeb] border-[#FFD301]/30',
      iconColor: 'text-[#b39500]',
      titleColor: 'text-[#8a7300]',
      valueColor: 'text-[#6b5900]'
    },
    negative: {
      bg: 'bg-[#fef2f2] border-[#E03C32]/20',
      iconColor: 'text-[#E03C32]',
      titleColor: 'text-[#b32d25]',
      valueColor: 'text-[#8b1a13]'
    }
  };
  const styles = variantStyles[variant];
  return <Card className={`flex flex-col h-full justify-between transition-shadow duration-200 ${styles.bg}`} data-id="element-233">
      <div className="flex justify-between items-start mb-2" data-id="element-234">
        <span className={`text-sm font-medium ${styles.titleColor}`} data-id="element-235">
          {title}
        </span>
        {icon && <div className={styles.iconColor} data-id="element-236">{icon}</div>}
      </div>

      <div className="flex items-baseline gap-2 mt-1" data-id="element-237">
        <h3 className={`text-2xl font-bold ${styles.valueColor}`} data-id="element-238">{value}</h3>
      </div>

      {(change || subtext) && <div className="mt-2 text-xs text-gray-500" data-id="element-239">
          {change && <span className={trend === 'up' ? 'text-green-600' : trend === 'down' ? 'text-red-600' : ''} data-id="element-240">
              {change}
            </span>}
          {subtext && <span className="ml-1" data-id="element-241">{subtext}</span>}
        </div>}
    </Card>;
}